import React, { AnchorHTMLAttributes } from 'react';
import styled from 'astroturf/react';

const Container = styled.a<{
  color: LinkButtonProps['color'];
  weight: LinkButtonProps['weight'];
  disabled: LinkButtonProps['disabled'];
}>`
  @import 'stylesheets/design_system/font';
  @include sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;

  &.weight-regular {
    font-weight: 400;
  }

  &:not(.disabled) {
    cursor: pointer;

    &.color-primary {
      color: $ds-primary-blue-active;
      text-decoration-color: $ds-primary-blue-active;
    }

    &.color-gray {
      color: $ds-gray-dark;
      text-decoration-color: $ds-gray-dark;
    }

    &.color-black {
      color: $ds-black;
      text-decoration-color: $ds-gray-dark;
    }

    &:hover {
      text-decoration-line: underline;
    }
  }

  &.disabled {
    color: #b1b1ba;
    cursor: not-allowed;
  }
`;

export type LinkButtonProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  color?: 'primary' | 'gray' | 'black';
  weight?: 'medium' | 'regular';
  disabled?: boolean;
};

export const LinkButton: React.FC<LinkButtonProps> = ({
  color = 'primary',
  weight = 'medium',
  disabled = false,
  href,
  children,
  onClick,
  ...props
}) => {
  return (
    <Container
      href={disabled ? undefined : href}
      color={color}
      weight={weight}
      aria-disabled={disabled}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      {...props}
    >
      {children}
    </Container>
  );
};
